import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';

/**
 * Native-only initialisation. No-op on web.
 */
export async function initNative() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setStyle({ style: Style.Light });
    App.addListener('appUrlOpen', ({ url }) => {
      const idx = url.indexOf('/auth');
      if (idx > -1) window.location.assign('/#' + url.substring(idx));
    });
    await SplashScreen.hide();
  } catch (err) {
    console.error('[native init] error', err);
  }
}
